import { Injectable } from "@angular/core";
import { EnergyService } from "../energy/energy.service";
import { SessionStateService } from "../../core/services/session-state.service";
import { HOUSE_PROFILE } from "../houses/houses.constants";
import { Observable } from "rxjs/Observable";
import { ApiService } from "../../core/services/api.service";
import { ClientTariff } from "./home.constants";

@Injectable()
export class HomeService {
  constructor(
    private apiService: ApiService,
    private sessionStateService: SessionStateService,
    private energyService: EnergyService
  ) {}

  getHouseTariff(houseId: string): Observable<any> {
    return this.apiService
      .get(`/equipment/houses/${houseId}/currenttariff`)
      .map((res) => {
        const key = res["currentTariff"];
        return ClientTariff[key];
      });
  }

  isConsumptionClient() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.CONSUMPTION
    );
  }

  isConsumptionClientSpain() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.CONSUMPTION_ES
    );
  }

  isOnlyConsumption(): boolean {
    return this.isConsumptionClient() || this.isConsumptionClientSpain();
  }

  isAutoConsumption() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.SELF_CONSUMPTION
    );
  }

  isCommunityConsumption() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.COMMUNITY_CONSUMPTION
    );
  }

  isCommunitySelfConsumption() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.COMMUNITY_SELFCONSUMPTION
    );
  }

  isCommunityProduction() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.COMMUNITY_PRODUCTION
    );
  }

  isCommunity() {
    return (
      this.isCommunityConsumption() ||
      this.isCommunitySelfConsumption() ||
      this.isCommunityProduction()
    );
  }

  isAutoConsumptionWithBattery() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile === HOUSE_PROFILE.STORAGE
    );
  }

  isMicroGeneration() {
    return (
      this.sessionStateService.getHouse() &&
      this.sessionStateService.getHouse().houseProfile ===
        HOUSE_PROFILE.MICROGENERATION
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/home/home.service.ts